import { RSAA } from "redux-api-middleware";
import { BASE_URL } from "../api/endpoints";
import { normalize, schema } from "normalizr";
const match_product = new schema.Entity(
  "match_products",
  {},
  { idAttribute: "biostorage_product_id" }
);
const mySchema = { match_products: [match_product] };

export default () => {
  return async (dispatch: any, getState: any) => {
    const state = getState();
    const customer_id = state.general.merchants.selectedMerchant
      ? state.general.merchants.selectedMerchant.customer_id
      : "";
    const selectedYear = state.general.year.selectedYear;
    dispatch({
      [RSAA]: {
        endpoint: `${BASE_URL}/api/v1/match_products?tax_year=${selectedYear}&merchant_id=${customer_id}`,
        method: "GET",
        headers: { "Content-Type": "application/json" },
        types: [
          "MATCH_REQUEST",
          {
            type: "MATCH_SUCCESS",
            payload: (action: any, state: any, res: any) => {
              const contentType = res.headers.get("Content-Type");
              if (contentType && ~contentType.indexOf("json")) {
                // Just making sure res.json() does not raise an error
                return res
                  .json()
                  .then((json: any) => normalize(json, mySchema));
              }
            },
          },
          "MATCH_ERROR",
        ],
      },
    });
  };
};
